import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { ICheckoutStock } from '../../../../../../interfaces/checkout.interface';

@Component({
    selector: 'chips-component',
    templateUrl: './chips.component.html',
    styleUrls: ['chips.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ChipsComponent implements OnInit {

    @Output() public newLotValue   = new EventEmitter(); // Número de lotes que o cliente escolheu
    @Output() public newPriceValue = new EventEmitter(); // Valor de gain/loss que o cliente escolheu

    @Input() public stock: ICheckoutStock;
    @Input() public getInvestments: number; // Retorna o total que será investido pelo cliente
    @Input() public priceEdited: number; // Preço editado, quando vem da dialog de edição de preço
    @Input() public isPriceChip: boolean; // Tipo do chip, que poderá retornar o novo número de contratos ou novo preço
    public dayTradeStress: any;

    public minChip:    number = 1;
    public mediumChip: number = 5;
    public highChip:   number = 10;

    private get isFutureMarket(): boolean {
      return this.stock.typeMarket === OrderMarketTypeEnum.Future;
    }

    public constructor() {
    }

    public ngOnInit(): void {
        if (this.stock) {
            this.dayTradeStress = this.stock.isDayTrade ? this.stock.stress.dayTradeValue : 1;
        }
    }

    public chipValue(valueChip: number): number {
      if (this.isPriceChip) {
        return valueChip;
      }
      if (this.stock) {
        if (this.isFutureMarket) {
          return this.roundValue(this.getInvestments / this.stock.buyAmount * valueChip, 1);
        }
        if (this.stock.isDayTrade) {
          return this.roundValue(this.getInvestments / this.stock.buyAmount * valueChip * this.stock.lotDefault, 1);
        }
        return this.roundValue(this.stock.lotDefault * valueChip * this.stock.unitPrice, 1);
      }
      return valueChip;
    }

    // Atualiza o número de lotes a investir, ou o preço de gain/loss
    public updateChip(value: number ) {
        this.isPriceChip ? this.updateValueScenario(value) : this.updateLotScenario(value);
    }

    // Cenário em que o cliente quer editar o número de contratos que quer operar
    public updateLotScenario(lot) {
        this.newLotValue.emit(lot * this.stock.lotDefault);
    }

    // Cenário em que o cliente quer editar o lucro/prejuízo do investimento
    public updateValueScenario(change: number): void {
      if (this.isFutureMarket) {
        const financialChange = change * this.stock.priceStep * this.stock.quoteFactor;
        this.newPriceValue.emit(financialChange);
      } else {
        this.newPriceValue.emit(change);
      }
    }

    public validateDisableChip(chipValue: number): boolean {
      if (this.isPriceChip) {
        const currentStopValue = this.priceEdited * this.stock.quoteFactor;
        let changeToValidate = chipValue;

        if (this.isFutureMarket) {
          changeToValidate = chipValue * this.stock.priceStep * this.stock.quoteFactor;
        }

        return currentStopValue - changeToValidate <= 0.001;
      } else {
        const investmentValue = this.chipValue(chipValue);
        return this.getInvestments - investmentValue <= 0;
      }
    }

    public validateMaxAmount(chipValue: number) {
        if (this.isPriceChip) {
            return true;
        } else {
            if (this.stock.isFractionary) {
                return this.stock.buyAmount + chipValue < this.stock.mainLotDefault;
            } else {
                return true;
            }
        }
    }

    public roundValue(value, factor) {
        return Math.ceil(value / factor) * factor;
    }
}
